export default [
  {
    path: "skill",
    name: "SkillWikiCreate",
    redirect: { name: "SkillWikiCreateSelf" },
    component: { render: h => h("router-view") },
    children: [
      {
        path: "knowledge/:id",
        name: "SkillWikiCreateSelf",
        component: () => import("@/views/System/SkillWikiInfo.vue"),
        meta: {
          title: "极客-知识树-百科"
        }
      }
    ]
  },
  {
    path: "column",
    name: "ColumnInfo",
    redirect: { name: "ColumnInfoSelf" },
    component: { render: h => h("router-view") },
    children: [
      {
        path: "knowledge/:id",
        name: "ColumnInfoSelf",
        component: () => import("@/views/System/ColumnInfo.vue"),
        meta: {
          title: "极客-知识树-百科"
        }
      }
    ]
  },
  {
    path: "interview",
    name: "InterviewInfo",
    redirect: { name: "InterviewInfoSelf" },
    component: { render: h => h("router-view") },
    children: [
      {
        path: "my/detail/:uuid",
        name: "InterviewInfoSelf",
        component: () => import("@/views/System/InterviewInfo.vue"),
        meta: {
          title: "极客-面试服务-面试详情"
        }
      }
    ]
  }
];
